var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-bar"},[_c('div',{staticClass:"charts-box"},[_c('div',{staticClass:"myChart-Activity-box",attrs:{"id":("myChart-Activity-" + _vm.projectID)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }